"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../../theme"));
const useStyles = (0, _styles.makeStyles)({
  monthLabel: {
    fontFamily: _theme.default.typography.proxima.semiBold,
    'font-size': '24px',
    'line-height': '29px',
    color: '#061556'
  },
  monthWeekdayLabels: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    justifyContent: 'center',
    marginBottom: _theme.default.spacing(1),
    fontSize: _theme.default.typography.pxToRem(10),
    margin: '20px 0px 10px 0px'
  },
  monthDaysLabel: {
    fontFamily: _theme.default.typography.proxima.regular,
    'font-size': '16px',
    color: '#787A7E',
    textAlign: 'center',
    minWidth: _theme.default.typography.pxToRem(35)
  },
  monthDays: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    justifyContent: 'center',
    textAlign: 'center'
  },
  monthWrapper: {
    minHeight: '374px',
    [_theme.default.breakpoints.up('xs')]: {
      margin: '30px 20px 0px 20px',
      minHeight: '0px'
    },
    [_theme.default.breakpoints.up('md')]: {
      margin: '30px 50px 0px 50px',
      minHeight: '374px'
    },
    [_theme.default.breakpoints.up('lg')]: {
      margin: 0,
      minHeight: '374px'
    }
  }
});
var _default = exports.default = useStyles;